import { render, staticRenderFns } from "./newUserPaid.vue?vue&type=template&id=1cb5d598&scoped=true&"
import script from "./newUserPaid.vue?vue&type=script&lang=js&"
export * from "./newUserPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5d598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb5d598')) {
      api.createRecord('1cb5d598', component.options)
    } else {
      api.reload('1cb5d598', component.options)
    }
    module.hot.accept("./newUserPaid.vue?vue&type=template&id=1cb5d598&scoped=true&", function () {
      api.rerender('1cb5d598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userPaymentTieredPenetrationRate/newUserPaid.vue"
export default component.exports